import Vue from 'vue'
import App from './App'
import colors from 'vuetify/es5/util/colors'
import router from './router'
import { store } from './store'
import DateFilter from './filters/date'
import FormattedDate from './filters/formatteddate'
import FormattedTime from './filters/formattedtime'
import LowerCase from './filters/lowercase'
import UpperCase from './filters/uppercase'
import toFixedOne from './filters/tofixedone'
import toFixedZero from './filters/tofixedzero'
import doNotShowNaNValue from './filters/donotshownanvalue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import ProgressCircularContainer from '@/components/Base/ProgressCircularContainer'
import VueI18n from 'vue-i18n'
import messages from './i18n'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'

Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'pt_BR', // set locate
  messages // set locale messages
})

Vue.use(VueClipboard)

Vue.use(Vuetify, {
  theme: {
    // primary: colors.blue.darken2,
    primary: '#cccccc',
    accent: colors.blue.accent2,
    secondary: colors.grey.lighten1,
    info: colors.blue.lighten1,
    warning: colors.amber.darken2,
    error: colors.red.accent4,
    success: colors.green.lighten2,
    inobram_base_color_light: '#008e43',
    // inobram_base_color: '#007a43',
    inobram_base_color: '#273770',
    // inobram_base_color_accent: '#00502e'
    inobram_base_color_accent: '#a2c745'
  }

  // theme: {
  //   primary: '#1976D2',
  //   secondary: '#424242',
  //   accent: '#82B1FF',
  //   error: '#FF5252',
  //   info: '#2196F3',
  //   success: '#4CAF50',
  //   warning: '#FFC107'
  // }

  // theme: {
  //   primary: {
  //     // base: '#1976D2',
  //     base: '#ccccaa',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#00ff0f',
  //     darken2: '#00ff0f',
  //     darken3: '#00ff0f',
  //     darken4: '#00ff0f'
  //   },
  //   secondary: {
  //     base: '#00ffff',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   },
  //   accent: {
  //     base: '#82B1FF',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   },
  //   error: {
  //     base: '#FF5252',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   },
  //   info: {
  //     base: '#2196F3',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   },
  //   success: {
  //     base: '#4CAF50',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   },
  //   warning: {
  //     base: '#FFC107',
  //     lighten5: '#aabbcc',
  //     lighten4: '#aabbcc',
  //     lighten3: '#aabbcc',
  //     lighten2: '#aabbcc',
  //     lighten1: '#aabbcc',
  //     darken1: '#ccffaa',
  //     darken2: '#ccffaa',
  //     darken3: '#ccffaa',
  //     darken4: '#ccffaa'
  //   }
  // }
})

Vue.use(VueAnalytics, {
  id: 'G-SVRDWZK3HN',
  router
})

Vue.config.productionTip = false

Vue.filter('date', DateFilter)
Vue.filter('formatted-date', FormattedDate)
Vue.filter('formattedTime', FormattedTime)
Vue.filter('lower-case-filter', LowerCase)
Vue.filter('upper-case-filter', UpperCase)
Vue.filter('toFixedOne', toFixedOne)
Vue.filter('toFixedZero', toFixedZero)
Vue.filter('doNotShowNaNValue', doNotShowNaNValue)
// Vue.component('app-snackbar', Snackbar)
Vue.component('app-progress-circular-container', ProgressCircularContainer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  created() {}
})



// WEBPACK FOOTER //
// ./src/main.js